export const localeFixed = (value, fixed=2) => {
    return parseFloat(parseFloat(value).toFixed(fixed)).toLocaleString()
}